<template>
  <auth-template>
    <b-col md="8">
      <b-card-group>
        <b-card no-body class="p-4">
          <b-card-body>
            <b-form>
              <h1>Login</h1>
            </b-form>
          </b-card-body>
        </b-card>
      </b-card-group>
    </b-col>
  </auth-template>
</template>


<script>
import AuthTemplate from '@/templates/auth/AuthTemplate'
import gRecaptcha from './recaptcha'
import miniToastr from 'mini-toastr'

export default {
  name: 'Login',
  components: {
    AuthTemplate,
    gRecaptcha
  },
  data () {
    return {
      usuario: {
        cpf: '',
        senha: ''
      },
      logando: false,
      titulo_toast: 'Alerta!',
      chavaCaptcha: process.env.KEY_RECAPTCHA
    }
  },
  created () {
    location.href=process.env.URL_LOGIN
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    login () {
      this.logando = true
      let data = {
        cpf: this.usuario.cpf.replace(/[^\d]+/g, ''),
        password: this.usuario.senha,
        captcha: window.grecaptcha.getResponse()
      }

      this.$store.dispatch('login', data).then((response) => {
        this.$router.push('/')
      }).catch(e => {
        let response = e.body

        if (response.msg !== '') {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.msg, this.titulo_toast, 5000)
        }

        if (response.data.erros) {
          let erros = Object.values(response.data)

          if (erros[0].captcha !== undefined) {
            for (let erro of erros[0].captcha) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro, this.titulo_toast, 5000)
            }
          }

          if (erros[0].password !== undefined) {
            for (let erro of erros[0].password) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro, this.titulo_toast, 5000)
            }
          }

          if (erros[0].cpf !== undefined) {
            for (let erro of erros[0].cpf) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro, this.titulo_toast, 5000)
            }
          }
        }
        this.logando = false
        this.reloadRecapcha()
      })
    },
    reloadRecapcha () {
      window.grecaptcha.reset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/LoginExterno.vue